import { get, post, put } from "../request.js";
import { useUserInfoStore } from "@/store/modules/userInfo";

// 安全檢查函數：確保只能操作當前登入用戶的數據
const validateCurrentUser = (studentId) => {
  const userStore = useUserInfoStore();
  const currentStudentId = userStore.student?.stuID;

  if (!currentStudentId) {
    throw new Error("用戶未登入");
  }

  if (studentId && studentId !== currentStudentId) {
    console.warn(
      `安全警告: 嘗試訪問其他用戶數據 - 請求ID: ${studentId}, 當前用戶ID: ${currentStudentId}`
    );
    throw new Error("無權限訪問其他用戶的數據");
  }

  return currentStudentId;
};

export const ApiPrize = {
  // 獲取所有獎品
  getAll: (activeOnly = true) => {
    return get(`/prize/all?active_only=${activeOnly}`);
  },

  // 獲取學生的獎品記錄 - 添加安全檢查
  getStudentPrizes: (studentId) => {
    const validatedStudentId = validateCurrentUser(studentId);
    return get(`/prize/student/${validatedStudentId}`);
  },

  // 合併抽獎API：後端自動處理資源分配（優先使用代幣，不足時使用機會）
  combinedDraw: () => {
    return post("/prize/combined/draw");
  },

  // 新增獎品記錄 - 添加安全檢查 (保留作為備用)
  addPrizeRecord: (data) => {
    if (data.student_id) {
      data.student_id = validateCurrentUser(data.student_id);
    }
    return post("/prize/record/add", data);
  },

  // 使用虛擬代幣抽獎 - 添加安全檢查 (保留作為備用)
  drawWithTokens: (data) => {
    if (data.student_id) {
      data.student_id = validateCurrentUser(data.student_id);
    }
    return post("/prize/token/draw", data);
  },

  // 領取獎品
  claimPrize: (recordId) => {
    return put(`/prize/claim/${recordId}`);
  },

  // 獲取指定日期範圍內的學生進度和獎品數據 - 添加安全檢查
  getStudentProgressAndPrizes: (studentId, startDate, endDate) => {
    const validatedStudentId = validateCurrentUser(studentId);

    if (!startDate && !endDate) {
      return get(`/prize/student/${validatedStudentId}/progress`);
    } else if (startDate && !endDate) {
      return get(
        `/prize/student/${validatedStudentId}/progress?start_date=${startDate}`
      );
    } else {
      return get(
        `/prize/student/${validatedStudentId}/progress?start_date=${startDate}&end_date=${endDate}`
      );
    }
  },
};

// 獲取學生進度（用於確認是否可以抽獎）- 添加安全檢查
export const ApiStudentProgress = {
  get: (studentId) => {
    const validatedStudentId = validateCurrentUser(studentId);
    return get(`/get_student_progress/${validatedStudentId}`);
  },
};
